/**
 * MongoDB duplicate key error code.
 * Source: mongodb/src/mongo/base/error_codes.yml
 */
export const DUPLICATE_KEY_ERROR = 11000;

/** True when `error` is a MongoDB duplicate-key (E11000) error, e.g. a unique-index violation. */
export function isDuplicateKeyError(error: unknown): boolean {
    return !!error && typeof error === "object" && "code" in error && (error as any).code === DUPLICATE_KEY_ERROR;
}
